import { api } from "../../app/api";
import { Options } from "../../common/types/requestOptions";

export interface TalentTag {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
}

export interface GetTalentTagsRequest {
  includeInactive?: boolean;
}

export const getTalentTags = (
  getTalentTagsRequest: GetTalentTagsRequest = {},
  { requestId }: Options,
) => {
  const { includeInactive } = getTalentTagsRequest;

  return api.get<TalentTag[]>("/projections/qry/tags", {
    requestId,
    auth: true,
    queryParams: {
      ...(includeInactive !== undefined && {
        includeInactive: includeInactive.toString(),
      }),
    },
  });
};
